import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';

import './UtilityBar.scss';

export default function UtilityBar({ children, className }) {
  return <div className={cn('cp-utility-bar', className)}>{children}</div>;
}

UtilityBar.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};
